export const getApplicationStep = (state) => state.applicationStep;
